import { useMemo } from 'react';
import useTransferListStore from '../store/transfer-list-store';

export function useTransferListItems() {
  const store = useTransferListStore();

  const excluded = useMemo(() => {
    const items =
      store.config?.items?.filter((x) => store.excluded?.includes(x.id)) ?? [];

    const ids = items?.map((x) => x.id);
    return { items, ids };
  }, [store.config?.items, store.excluded]);

  const all = useMemo(() => {
    const items = store.config?.items ?? [];

    const ids = items.map((x) => x.id);
    return { items, ids };
  }, [store.config?.items]);

  const groupedItems = useMemo(() => {
    return store.config?.groupedItems ?? [];
  }, [store.config?.groupedItems]);

  const included = useMemo(() => {
    let items = store.excluded
      ? all.items.filter((x) => !store.excluded?.includes(x.id))
      : all.items;

    if (store.config?.sortable) {
      items = items.sort((a, b) => {
        if (
          (store.included?.indexOf(a.id) ?? 0) >
          (store.included?.indexOf(b.id) ?? 0)
        )
          return 1;
        if (
          (store.included?.indexOf(a.id) ?? 0) <
          (store.included?.indexOf(b.id) ?? 0)
        )
          return -1;
        return 0;
      });
    }
    const ids = items.map((x) => x.id);
    return { items, ids };
  }, [
    store.config?.items,
    store.config?.sortable,
    store.excluded,
    store.included,
  ]);

  return { all, included, excluded, groupedItems };
}
